import {
  styled,
  Flex,
  $primaryColorsGreen
  // $fontWeightBold, Box
} from "@acko-tech/building-blocks.ui.common";
// import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Wrapper = styled(Flex)`
  box-sizing: border-box;
  background: white;
`;

export const CardWrapper = styled(Flex)`
  box-sizing: border-box;
  padding: 32px 20px;
  min-height: ${(props: any) => {
    if (props.isAmazon) {
      return props.isAmazonPrime ? "1000px" : "800px";
    }
    return "calc(100vh - 90px)";
  }};
`;

export const StickyContainer = styled.div`
  ${props => props.nonSticky && ``}
  ${props =>
    !props.nonSticky &&
    `position:fixed;
  box-shadow: ${props =>
    !props.noShadow ? "0px -2px 4px rgba(32, 35, 44, 0.05);" : "none;"}
  box-sizing:border-box;
  padding:20px;
  background-color:white;`}
  bottom: ${props => (props.bottom ? props.bottom : 0)};
  left: ${props => (props.left ? props.left : 0)};
  z-index: 1;
  width: ${props => (props.width ? props.width : "100%")};
  }
`;

// export const $primaryColorsV2 = {
//   disabled:"#E5E5E5",
//   lightest: "#f2faf7",
//   light: "#0FA457",
//   normal: "#0FA457",
//   dark: "#149452"
// };

export const $primaryColorsV2 = $primaryColorsGreen;

export const $buttonStyles = {
  zIndex: "1",
  background: "white",
  padding: "20px",
  boxSizing: "border-box",
  boxShadow: "0px -2px 4px rgba(32, 35, 44, 0.05)"
};

export const $grayLighter = "#F0F0F6";

export const $pixelSizesUtilObj = {
  4: "4px",
  8: "8px",
  12: "12px",
  16: "16px",
  20: "20px",
  22: "22px",
  24: "24px",
  28: "28px",
  32: "32px"
};

export const MaxWidthContainer = styled.div`
  @media (min-width: 768px) {
    max-width: 400px;
  }
`;

// export const LandingPageCardWrapper = styled(Flex)`
//   box-sizing: border-box;
//   background: #ffffff;
//   height: auto;
// `;

// export const TitleAndCarContainer = styled(Flex)`
//   justify-content: space-between;
//   margin-bottom: 10px;
//   padding-left: 20px;
//   padding-right: 20px;
// `;

// export const LargeHeadingContainer = styled(Flex)`
//   margin-top: 5px;
//   width: 100%;
//   ${props => (props.isDescriptionVariantTwo ? `flex-direction: column` : "")}
//   @media screen and (max-width: 350px) {
//     width: 62%;
//   }
// `;

// export const SmallHeadingContainer = styled(Flex)`
//   padding: 20px 0px 0px 20px;
// `;

// export const LargeHeading = styled(Text)`
//   font-weight: ${$fontWeightBold};
//   font-size: 20px;
//   line-height: 24px;
//   color: #0b0e34;
//   margin-bottom: 10px;
// `;

// export const SmallHeading = styled(Text)`
//   font-weight: ${$fontWeightBold};
//   font-weight: bold;
//   font-size: 12px;
//   line-height: 16px;
//   letter-spacing: 0.01em;
//   color: #00a871;
// `;

// export const CarImage = styled.img`
//   width: 136px;
//   height: 99px;
//   margin-top: 12px;
// `;

// export const BannerImageContainer = styled(Flex)`
//   min-height: 130px;
//   padding: 0 20px;
//   box-sizing: border-box;
//   object-fit: contain;
//   background: #fff;
//   margin-top: 20px;

//   @media screen and (max-width: 350px) {
//     min-height: 110px;
//   }
// `;

// export const BannerImage = styled.img`
//   margin: 0 auto;
//   width: 100%;
//   object-fit: contain;
// `;

// // OD & Commercial Landing Page
// export const RatingsAndReviewContainer = styled(Flex)`
//   flex-direction: column;
//   background: #ffffff;
//   // margin-top: 8px;
//   padding: 20px 0px;
// `;

// export const LPBadge = styled(Box)`
//   font-weight: bold;
//   font-size: 10px;
//   line-height: 16px;
//   letter-spacing: 0.01em;
//   color: #169b4b;
//   background: #cbf9bb;
//   border-radius: 4px;
//   width: fit-content;
//   max-width: ${props => (props.maxWidth ? props.maxWidth : "160px")};
//   padding: 7px 10px;
//   margin: 0 0 8px 0;
// `;

// export const DescriptionVariantTwoText = styled(Text)`
//   margin-top: 10px;
// `;
